import {
  CREATE_ALERT_V3,
  EDIT_ALERT_V3,
} from "cortex/ui/src/fleet/redux-store/alerts-v3/actions";
import { createPromiseApiAction } from "cortex/ui/src/redux-store/api-sagas/actions";
import { AppDispatch } from "cortex/ui/src/redux-store/store";

import { Alert, AlertPriority, FormErrors, FormValues } from "./model";

function buildParams(values: FormValues) {
  const {
    createResolvableIncident,
    frequency,
    threshold,
    priorities,
    sources,
  } = values;
  return {
    notification_only: !createResolvableIncident,
    frequency,
    threshold,
    severity_levels: priorities,
    sources,
  };
}

export function createOrEditAlert(values: FormValues) {
  return async (dispatch: AppDispatch): Promise<Boolean | null> => {
    try {
      const {
        description,
        emailAddresses: users,
        eventNames,
        id,
        name,
        priority,
        targetDevices: targets,
      } = values;
      const params = buildParams(values);

      if (id) {
        const resp = await createPromiseApiAction(dispatch, EDIT_ALERT_V3, [
          id,
          name,
          eventNames,
          targets,
          users,
          params,
          description,
          priority,
        ]);
        return !!resp;
      } else {
        const resp = await createPromiseApiAction(dispatch, CREATE_ALERT_V3, [
          name,
          eventNames,
          targets,
          users,
          params,
          description,
          priority,
        ]);
        return !!resp;
      }
    } catch (_err) {
      return null;
    }
  };
}

export type CreateEditAlertHandler = (
  values: FormValues,
) => Promise<Boolean | null>;

export function alertToForm(alert: Alert): FormValues {
  const targetDevices = alert?.target_devices
    ? Object.keys(alert.target_devices).map((t: string) => t.replace("-", "_"))
    : [];
  return {
    createResolvableIncident: !alert?.notification_only || false,
    description: alert?.description ?? "",
    emailAddresses: alert?.user_ids ?? [],
    eventNames: alert?.target_events ?? [],
    frequency: alert?.min_occurrence ?? 5,
    id: alert?.id,
    name: alert?.name ?? "",
    priorities: alert?.severity_levels ?? [],
    priority: (alert?.priority as AlertPriority | null) ?? undefined,
    sources: alert?.source_ids ?? [],
    targetDevices,
    threshold: alert?.time_range ?? 10,
  };
}

export function validateAlert(state: FormValues): FormErrors {
  const error: FormErrors = {};

  if (!state.name?.trim()) {
    error.name = "Name is required.";
  }
  if (!state.targetDevices || state.targetDevices.length === 0) {
    error.targetDevices = "At least one target device is required.";
  }
  if (!state.emailAddresses || state.emailAddresses.length === 0) {
    error.emailAddresses = "At least one email address is required.";
  }
  if (state.frequency && isNaN(state.frequency)) {
    error.frequency = "Frequency must be a number.";
  }
  if (state.frequency && state.frequency < 0) {
    error.frequency = "Frequency cannot be less than 0.";
  }
  if (state.threshold && isNaN(state.threshold)) {
    error.threshold = "Threshold must be a number.";
  }
  if (state.threshold && state.threshold < 0) {
    error.threshold = "Threshold cannot be less than 0.";
  }

  return error;
}
